module.exports = __webpack_public_path__ + "static/media/user.b188961b.svg";